<template>
  <div class="add__user">
    <v-dialog v-model="value" max-width="800px" persistent>
      <v-card>
        <v-toolbar>
          <v-btn icon @click="close2" :disabled='progress'>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title
            >Добавить пользователя: {{ user.name }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <!-- <v-btn @click="save2"> <v-icon left>save</v-icon>Записать </v-btn> -->
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-text-field
              :rules="rules.emailRules"
              prepend-icon="email"
              type="email"
              required
              label="Логин (изменить потом нельзя)"
              v-model="user.email"
            ></v-text-field>

            <v-row>
              <v-col cols="4" class="pt-1 pb-1">
                <v-text-field
                  :rules="rules.nameRules"
                  required
                  label="*Фамилия"
                  v-model="user.famil"
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="pt-1 pb-1">
                <v-text-field
                  :rules="rules.nameRules"
                  required
                  label="*Имя"
                  v-model="user.name"
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="pt-1 pb-1">
                <v-text-field
                  label="Отчество"
                  v-model="user.otch"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="pt-1 pb-1">
                <v-text-field
                  placeholder="(xxx)xxx xx xx"
                  prepend-icon="phone"
                  v-mask="rules.phonemask"
                  prefix="+7"
                  :rules="rules.phoneRules"
                  label="*№ телефона"
                  v-model="user.phone"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="pt-1 pb-1">
                <v-text-field
                  label="Должность"
                  v-model="user.position"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pt-1 pb-1">
                <v-select
                  v-model="user.role"
                  :items="roles"
                  item-text="name"
                  item-value="role"
                  label="Роль"
                  required
                  :rules="rules.emptyRules"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close2" :disabled='progress'>Отмена (закрыть)</v-btn>
          <v-btn @click="save2" :disabled='progress' :loading='progress'>Записать</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Globalrules from "./api/rules";
import Swal from "sweetalert2";

export default {
  name: "add__user",
  components: {
  },
  data: () => ({
    rules: Globalrules,
    valid: true,
    user: {
      email: "",
      famil: "",
      name: "",
      otch: "",
      position: "",
      phone: "",
      phone_note: "",
      address: "",
      bio: "",
      date: "",
      emailContact: "",
      role: "",
      active: false,
    },
    defaultUser: {
      email: "",
      famil: "",
      name: "",
      otch: "",
      position: "",
      phone: "",
      phone_note: "",
      address: "",
      bio: "",
      date: "",
      emailContact: "",
      role: "",
      active: false,
    },
    progress: false
  }),
  props: {
    value: { type: Boolean, default: false },
  },
  methods: {
    clearBtn(interval){
      this.saveBtnText = 'Записать'
      clearInterval(interval)
    },
    save2() {
      this.progress = true
      const clearInter = setInterval(()=>this.saveBtnText = `${this.saveBtnText} `+ '.',500)
      if (!this.$refs.form.validate()) {
        Swal.fire({
          icon: "error",
          title: "Не все поля заполнены правильно",
          text: "Проверьте правильность заполнения обязательных полей",
        });
        this.progress = false
        this.clearBtn(clearInter)
        return;
      }

      var data = {
        email: this.user.email,
        famil: this.user.famil,
        name: this.user.name,
        otch: this.user.otch,
        position: this.user.position,
        phone: this.user.phone,
        phone_note: this.user.phone_note,
        address: this.user.address,
        bio: this.user.bio,
        date: this.user.date,
        emailContact: this.user.email,
        role: this.user.role,
        active: this.user.active,
      };

      this.$store
        .dispatch("addUserOfFirm2", data)
        .then(() => {
          if (this.$store.getters.getErrorApi == "EMAILNOTUNIQUE") {
            Swal.fire({
              icon: "error",
              title: "Email не уникальный",
              text:
                "Пользователь с email " +
                this.user.email +
                " уже зарегистрирован в системе.",
            });
            this.progress = false
            this.clearBtn(clearInter)
            return;
          }
          if (this.$store.getters.getErrorApi == "OK") {
            Swal.fire({
              icon: "success",
              title: "Сохранено!",
              text: "Пользователь успешно добавлен.",
            });
            this.items = this.$store.getters.getAgentFirmSorts;
            this.progress = false
            this.clearBtn(clearInter)
            this.close2();
          }

        })
        .catch((error) => {
          this.progress = false
          Swal.fire({
            icon: "error",
            title: "Сохранено!",
            text: "Пользователь не добавлен.",
          });
          this.clearBtn(clearInter)
        });
    },
    close2() {
      this.$emit("close", false);
      setTimeout(() => {
        this.user = Object.assign({}, this.defaultUser);
        this.$refs.form.resetValidation();
      }, 300);
    },
  },
  computed: {
    roles() {
      const role = this.getRoles()

      return [role[0], role[15], role[16], role[17]];
    },
  },
};
</script>
<style lang="sass" scoped>
</style>
